import {Injector, NgModule} from '@angular/core';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserWarningComponent, CoreModule, DeviceService, UiConfigService} from '@lv1871/core';
import {settingsFactory} from '../services/setup/settings.factory';
import {AntragsannahmeModule} from '@lv1871/antragsannahme';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {PathInterceptor} from '../services/path.interceptor';
import {AppInitializer} from '../services/setup/app.initializer';
import {AntragWrapperComponent} from './antrag-wrapper/antrag-wrapper.component';
import {createCustomElement} from '@angular/elements';
import {provideMatomo, withRouter} from 'ngx-matomo-client';


@NgModule({ declarations: [AntragWrapperComponent],
    exports: [], imports: [CommonModule,
        FormsModule,
        // NgxMatomoTrackerModule.forRoot({
        //   //mode: MatomoInitializationMode.
        // }),
        // MatomoRouterModule.forRoot(),
        CoreModule.forRoot(settingsFactory),
        AntragsannahmeModule.forRoot()],
    providers: [
        UiConfigService,
        AppInitializer,
        provideMatomo({
          mode: 'deferred'
        }, withRouter()),
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: HTTP_INTERCEPTORS, useClass: PathInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AntragModule {
  constructor(private injector: Injector, private _deviceService: DeviceService) {
  }

  public addCustomElements() {
    if (!customElements.get('lv-app-antrag')) {
      const antragCustomElement = this._deviceService.unsupportedBrowser() ?
          createCustomElement(BrowserWarningComponent, {injector: this.injector})
          : createCustomElement(AntragWrapperComponent, {injector: this.injector});
      customElements.define('lv-app-antrag', antragCustomElement);
    }
  }
}
